import axios from 'axios'
import qs from 'qs'
import router from '../router'
import md5 from 'js-md5'

const SIGNKEY = 'key=4a7a00c7cc372d69'

const Message = () => {}
// create an axios instance
const service = axios.create({
    baseURL: '', // url = base url + request url
    timeout: 30000 // request timeout
})
// request interceptor
service.interceptors.request.use(
    (config) => {
        if (router.app._route.params.id) {
            config.headers['siteId'] =
                router.app._route.params.id === 'zhongguo'
                    ? 0
                    : router.app._route.params.id
        }

        // 全局参数签名
        delete config.data.sign
        let keys = Object.keys(config.data)
        keys.sort()
        let sortData = {}
        keys.forEach((key) => {
            sortData[key] = config.data[key]
        })
        const p = `${qs.stringify(sortData) &&
            `${qs.stringify(sortData)}&`}${SIGNKEY}`
        const sign = {
            sign: md5(p).toUpperCase()
        }
        Object.assign(config.data, sign)

        if (config.method === 'post') {
            config.headers['content-type'] = 'application/x-www-form-urlencoded'

            config.data = qs.stringify(config.data)
        }

        if (config.method === 'get') {
            config.url += '?' + qs.stringify(config.data)
        }

        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    (response) => {
        const res = response.data
        // if the custom code is not 20000, it is judged as an error.
        if (+res.code !== 200) {
            // 天地图逆地理编码查询
            if (response.status !== 200) {
                return Promise.reject(
                    new Error(res.msg || res.data.msg || 'Error')
                )
            }
        } else {
            return res
        }
    },
    (error) => {
        Message({
            message: error.msg || '服务器开小差了，请稍后再试!',
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    }
)

export default service
